DR.casestudies = DR.casestudies || {};
DR.casestudies.struct = DR.casestudies.struct || {};
DR.casestudies.select = DR.casestudies.select || {};
/** @extends {DR._Base} */
DR.casestudies.struct.Item = function(par){
	/** @private */
	this._t = 1348;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.cover)) this.cover = DR._Base.cast(par.cover);
	if(DR._Base.is(par.coverMobile)) this.coverMobile = DR._Base.cast(par.coverMobile);
	if(DR._Base.is(par.html)) this.html = String(par.html||'');
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.langs)){
		var tmp = [];
		for( var k in par.langs ) tmp.push(String(par.langs [k]||''));
		this.langs = tmp;
	}
	if(DR._Base.is(par.metaDescription)) this.metaDescription = String(par.metaDescription||'');
	if(DR._Base.is(par.metaTitle)) this.metaTitle = String(par.metaTitle||'');
	if(DR._Base.is(par.title)) this.title = String(par.title||'');
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
};
DR._Base._types[1348] = DR.casestudies.struct.Item;
DR.casestudies.struct.Item[__P] = new DR._Base;
DR.casestudies.struct.Item[__P][__C] = DR.casestudies.struct.Item;
/** @type {DR.roadgames.struct.Pic} */
DR.casestudies.struct.Item.prototype.cover = null;
/** @type {DR.roadgames.struct.Pic} */
DR.casestudies.struct.Item.prototype.coverMobile = null;
/** @type {String} */
DR.casestudies.struct.Item.prototype.html = null;
/** @type {Number} */
DR.casestudies.struct.Item.prototype.id = null;
/** @type {Array.<String>} */
DR.casestudies.struct.Item.prototype.langs = null;
/** @type {String|null} */
DR.casestudies.struct.Item.prototype.metaDescription = null;
/** @type {String|null} */
DR.casestudies.struct.Item.prototype.metaTitle = null;
/** @type {String} */
DR.casestudies.struct.Item.prototype.title = null;
/** @type {String} */
DR.casestudies.struct.Item.prototype.url = null;

/** @extends {DR._Select} */
DR.casestudies.select.Item = function(){
	this._fields = {};
};
DR.casestudies.select.Item[__CL] = "CaseStudies__Item";
DR.casestudies.select.Item[__P] = new DR._Select;
DR.casestudies.select.Item[__P][__C] = DR.casestudies.select.Item;
/** @param {boolean} [v]
  * @return {DR.casestudies.select.Item} */
DR.casestudies.select.Item.prototype.cover = function(v){ this._fields.cover = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.casestudies.select.Item} */
DR.casestudies.select.Item.prototype.coverMobile = function(v){ this._fields.coverMobile = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.casestudies.select.Item} */
DR.casestudies.select.Item.prototype.html = function(v){ this._fields.html = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.casestudies.select.Item} */
DR.casestudies.select.Item.prototype.id = function(v){ this._fields.id = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.casestudies.select.Item} */
DR.casestudies.select.Item.prototype.langs = function(v){ this._fields.langs = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.casestudies.select.Item} */
DR.casestudies.select.Item.prototype.metaDescription = function(v){ this._fields.metaDescription = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.casestudies.select.Item} */
DR.casestudies.select.Item.prototype.metaTitle = function(v){ this._fields.metaTitle = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.casestudies.select.Item} */
DR.casestudies.select.Item.prototype.title = function(v){ this._fields.title = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.casestudies.select.Item} */
DR.casestudies.select.Item.prototype.url = function(v){ this._fields.url = !DR._Base.is(v) || !!v; return this; };

/** @extends {DR._Base} */
DR.casestudies.struct.GetAllRe = function(par){
	/** @private */
	this._t = 1352;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.items)){
		var tmp = [];
		for( var k in par.items ) tmp.push(DR._Base.cast(par.items [k]));
		this.items = tmp;
	}
	if(DR._Base.is(par.pgs)) this.pgs = (parseInt(par.pgs)||0);
};
DR._Base._types[1352] = DR.casestudies.struct.GetAllRe;
DR.casestudies.struct.GetAllRe[__P] = new DR._Base;
DR.casestudies.struct.GetAllRe[__P][__C] = DR.casestudies.struct.GetAllRe;
/** @type {Array.<DR.casestudies.struct.Item>} */
DR.casestudies.struct.GetAllRe.prototype.items = null;
/** @type {Number} */
DR.casestudies.struct.GetAllRe.prototype.pgs = null;

/** @extends {DR._Method} */
DR.casestudies.Get = function(par){
	this.select = [];
	/** @private */
	this._t = 1350;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1350] = DR.casestudies.Get;
DR.casestudies.Get[__CL] = "CaseStudies__Get";
DR.casestudies.Get[__P] = new DR._Method;
DR.casestudies.Get[__P][__C] = DR.casestudies.Get;
/** @type {Number} */
DR.casestudies.Get.prototype.id = null;
/** @type {DR.casestudies.struct.Item} */
DR.casestudies.Get.prototype.re = null;

/** @extends {DR._Method} */
DR.casestudies.GetAll = function(par){
	this.select = [];
	/** @private */
	this._t = 1353;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1353] = DR.casestudies.GetAll;
DR.casestudies.GetAll[__CL] = "CaseStudies__GetAll";
DR.casestudies.GetAll.SECTION_CORPORATE = "corporate";
DR.casestudies.GetAll.SECTION_TEAM_BUILDING = "team_building";
DR.casestudies.GetAll.SECTION_BUSINESS = "business";
DR.casestudies.GetAll.SECTION_CITY = "city";
DR.casestudies.GetAll[__P] = new DR._Method;
DR.casestudies.GetAll[__P][__C] = DR.casestudies.GetAll;
/** @type {Number} */
DR.casestudies.GetAll.prototype.count = null;
/** @type {Number} */
DR.casestudies.GetAll.prototype.pg = null;
/** @type {String} */
DR.casestudies.GetAll.prototype.section = null;
/** @type {DR.casestudies.struct.GetAllRe} */
DR.casestudies.GetAll.prototype.re = null;

D.loaded();